import { render, staticRenderFns } from "./ManageReservationTypes.vue?vue&type=template&id=5d9f226b&scoped=true"
import script from "./ManageReservationTypes.vue?vue&type=script&lang=js"
export * from "./ManageReservationTypes.vue?vue&type=script&lang=js"
import style0 from "./ManageReservationTypes.vue?vue&type=style&index=0&id=5d9f226b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9f226b",
  null
  
)

export default component.exports